export class TableFiltersModel {
  [key: string]: any;
}
